import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { MatterGetOneV2ResponseDto } from '../../../../backend/src/matter/dto/matter-get-one-v2.dto';
import { ForbiddenStatuses } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { useRequestMatterAccess } from '@/api/mutations/useRequestMatterAccess';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterV2 = (id?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const { t } = useTranslation();
  const { mutate: requestMatterAccess } = useRequestMatterAccess();

  const navigate = useNavigate();

  const getMatterData = async () => {
    const response = await fetch(`${APIBaseChronos}/api/matters/${id}`, fetchConfigGET);

    // Check if the user is not authorised to view this matter
    if (response.status === 403) {
      const r = await response.json();
      if (r.message && r.message == ForbiddenStatuses.ForbiddenNoAccess) {
        toast(`You are not ${t('authorised')} to view this matter. Click here if you would like to request access.`, {
          action: {
            label: 'Request Access',
            onClick: () => {
              if (id) {
                requestMatterAccess(id);
              }
            },
          },
          duration: 6000,
          style: {
            width: '700px',
            right: '10px',
          },
        });
        navigate(`/matters`);
      }
      navigate(`/matters`);
      return;
    }

    if (!response.ok) {
      throw new Error('Fetching matter data failed');
    }

    return await response.json();
  };

  return useQuery<MatterGetOneV2ResponseDto, Error>([QueryEntity.Matter, id], getMatterData, {
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};
